import Cookies from 'universal-cookie';
import axios from 'axios';
import parse from 'url-parse';

const reloadUrl = () => {
    const url = parse(window.location, true);

    document.location.href = `${url.protocol}//${url.host}${url.pathname}`;

    return false;
};

const fetch = async (uri, postData, storeData) => {
    if (process.env.REACT_APP_TRUE_SERVER || (process.env.REACT_APP_TRUE_AUTH && uri.indexOf('logged') > -1)) {
        const cookies = new Cookies()
        const cookieToken = cookies.get('thetoken')
        if (cookieToken) {
            const config = {
                headers: {
                    'Authorization': `Bearer ${cookieToken}`,
                    'Access-Control-Allow-Origin': '*'
                }
            };

            if (postData) {
                return await axios.post(
                    `${process.env.REACT_APP_SERVER_URI}${uri}`,
                    postData,
                    config
                );
            }

            return await axios.get(`${process.env.REACT_APP_SERVER_URI}${uri}`, config);
        }

        return reloadUrl();
    }

    return reloadUrl();
};

export default fetch;
